import { render, staticRenderFns } from "./A_SettingBasicInfo.vue?vue&type=template&id=d4cca3dc&scoped=true&"
import script from "./A_SettingBasicInfo.vue?vue&type=script&lang=js&"
export * from "./A_SettingBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cca3dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4cca3dc')) {
      api.createRecord('d4cca3dc', component.options)
    } else {
      api.reload('d4cca3dc', component.options)
    }
    module.hot.accept("./A_SettingBasicInfo.vue?vue&type=template&id=d4cca3dc&scoped=true&", function () {
      api.rerender('d4cca3dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/setting/A_SettingBasicInfo.vue"
export default component.exports